import { render, staticRenderFns } from "./HospitalizacionView.vue?vue&type=template&id=41091b2e"
import script from "./HospitalizacionView.vue?vue&type=script&lang=js"
export * from "./HospitalizacionView.vue?vue&type=script&lang=js"
import style0 from "./HospitalizacionView.vue?vue&type=style&index=0&id=41091b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports